import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IGetActividadesPendienteAsignacion,
  IGetDashboardBalanceDependenciaTramites,
  IGetDashboardDetalleActividades, IGetDashboardGlobalTramites,
  IGetDashboardNumeroTramitesPorFecha, IGetDashboardNumeroTramitesPorMesByRangoFecha,
  IGetDashboardTotalTramies,
  IGetDashboardTramiteActividadesPorDependencia,
  IGetDashboardTramitePorDependencia, IGetDashboardTramitePorDependenciaByRangoFecha,
  IGetDashboardTramitePorDependenciaDetalle,
  IGetTipoTramiteFuncionario,
  IGetTramiteRegistroSeleccionFechas,
  PatchTramRegistroObservaciones
} from '../../shared/interfaces/database/tramite';
import { QueryParam, Utils } from "lib-base";

@Injectable({
  providedIn: 'root'
})
export class TramRegistroService {
  private readonly baseUrl = `${environment.apiUrl}/api/tram-registro`;

  constructor(private http: HttpClient) { }

  rechazarTramite(tramRegistroId: number, observaciones: string): Observable<string> {
    const requestBody = { observaciones } as PatchTramRegistroObservaciones;
    return this.http.patch(`${this.baseUrl}/rechazar/${tramRegistroId}`, requestBody, { responseType: 'text' });
  }

  getDashboardTotalTramites(startDate: string, endDate: string): Observable<IGetDashboardTotalTramies> {
    const params = new HttpParams().set('startDate', startDate).set('endDate', endDate);
    return this.http.get<IGetDashboardTotalTramies>(`${this.baseUrl}/dashboard/total-tramites`, { params });
  }

  getDashboardNumeroTramitesPorFecha(startDate: string, endDate: string, truncUnit: 'day' | 'week' | 'month'): Observable<IGetDashboardNumeroTramitesPorFecha[]> {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate)
      .set('truncUnit', truncUnit);
    return this.http.get<IGetDashboardNumeroTramitesPorFecha[]>(`${this.baseUrl}/dashboard/numero-tramites-por-fecha`, { params });
  }

  getDashboardTramitePorDependencia(startDate?: string, endDate?: string): Observable<IGetDashboardTramitePorDependencia[]> {
    const url = `${this.baseUrl}/dashboard/tramite-por-dependencia`;
    let param: QueryParam[] = [];
    if (startDate)
      param.push({ key: 'startDate', value: startDate });
    if (endDate)
      param.push({ key: 'endDate', value: endDate });

    return this.http.get<IGetDashboardTramitePorDependencia[]>(Utils.createQueryParams(url, param));
  }

  getDashboardBalanceDependenciaTramites(startDate?: string, endDate?: string): Observable<IGetDashboardBalanceDependenciaTramites[]> {
    const url = `${this.baseUrl}/dashboard/balance-dependencia-tramites`;
    const params: QueryParam[] = [];
    if (startDate)
      params.push({ key: 'startDate', value: startDate });
    if (endDate)
      params.push({ key: 'endDate', value: endDate });

    return this.http.get<IGetDashboardBalanceDependenciaTramites[]>(Utils.createQueryParams(url, params));
  }

  getTramiteRegistroSeleccionFechas(): Observable<IGetTramiteRegistroSeleccionFechas[]> {
    return this.http.get<IGetTramiteRegistroSeleccionFechas[]>(`${this.baseUrl}/seleccion-fechas`);
  }

  getDashboardTramitePorDependenciaDetalle(dependenciaId: number, tramEstadoId?: number, fecha?: string): Observable<IGetDashboardTramitePorDependenciaDetalle[]> {
    let params = new HttpParams();
    if (tramEstadoId) {
      params = params.set('tramEstadoId', tramEstadoId.toString());
    }
    if (fecha) {
      params = params.set('fecha', fecha);
    }

    return this.http.get<IGetDashboardTramitePorDependenciaDetalle[]>(`${this.baseUrl}/dashboard/tramite-por-dependencia-detalle/${dependenciaId}`, { params });
  }

  getDashboardTramiteActividadesPorDependencia(tipoTramiteId: number, dependenciaId: number, secUsuarioId?: number, fecha?: string): Observable<IGetDashboardTramiteActividadesPorDependencia[]> {
    let params = new HttpParams();
    if (secUsuarioId) {
      params = params.set('secUsuarioId', secUsuarioId.toString());
    }
    if (fecha) {
      params = params.set('fecha', fecha);
    }

    return this.http.get<IGetDashboardTramiteActividadesPorDependencia[]>(`${this.baseUrl}/dashboard/tramite-actividades-por-dependencia/${tipoTramiteId}/${dependenciaId}`, { params });
  }

  getTipoTramiteFuncionario(tipoTramiteId: number): Observable<IGetTipoTramiteFuncionario[]> {
    return this.http.get<IGetTipoTramiteFuncionario[]>(`${this.baseUrl}/tipo-tramite-funcionario/${tipoTramiteId}`);
  }

  getDashboardDetalleActividades(tipoTramiteId: number, dependenciaId: number, secUsuarioId?: number, fecha?: string): Observable<IGetDashboardDetalleActividades[]> {
    let params = new HttpParams();
    if (fecha) {
      params = params.set('fecha', fecha);
    }
    return this.http.get<IGetDashboardDetalleActividades[]>(`${this.baseUrl}/dashboard/detalle-actividad/${tipoTramiteId}/${dependenciaId}/${secUsuarioId}`, { params });
  }

  getDashboardNumeroTramitesPorMesByRangoFecha(startDate: string, endDate: string): Observable<IGetDashboardNumeroTramitesPorMesByRangoFecha[]> {
    const url = `${this.baseUrl}/dashboard/numero-tramites-por-mes-by-rango-fecha`;
    const params: QueryParam[] = [
      { key: 'startDate', value: startDate },
      { key: 'endDate', value: endDate }
    ];

    return this.http.get<IGetDashboardNumeroTramitesPorMesByRangoFecha[]>(Utils.createQueryParams(url, params));
  }

  getDashboardTramitePorDependenciaByRangoFecha(startDate: string, endDate: string): Observable<IGetDashboardTramitePorDependenciaByRangoFecha[]> {
    const url = `${this.baseUrl}/dashboard/tramite-por-dependencia-by-rango-fecha`;
    const params: QueryParam[] = [
      { key: 'startDate', value: startDate },
      { key: 'endDate', value: endDate }
    ];

    return this.http.get<IGetDashboardTramitePorDependenciaByRangoFecha[]>(Utils.createQueryParams(url, params));
  }

  getDashboardGlobalTramitesByRangoFecha(startDate: string, endDate: string): Observable<IGetDashboardGlobalTramites[]> {
    const url = `${this.baseUrl}/dashboard/global-tramites-by-rango-fecha`;
    const params: QueryParam[] = [
      { key: 'startDate', value: startDate },
      { key: 'endDate', value: endDate }
    ];

    return this.http.get<IGetDashboardGlobalTramites[]>(Utils.createQueryParams(url, params));
  }

  getActividadesPendienteAsignacion(): Observable<IGetActividadesPendienteAsignacion[]> {
    return this.http.get<IGetActividadesPendienteAsignacion[]>(`${this.baseUrl}/dashboard/pendiente-asignacion`);
  }


}
